import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';
import { useAuth } from '../AuthContext';
import './Header.css';

const Header = ({ onToggleSidebar, isSidebarOpen, isMobile }) => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [currentTime, setCurrentTime] = useState('');
    const [showMenu, setShowMenu] = useState(false);
    const timeoutRef = useRef(null);
    const title = import.meta.env.VITE_APP_TITLE || '自動化監測整合視覺平台';
    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            const year = now.getFullYear() - 1911;
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const timeString = `民國${year}年 ${month}/${day} ${hours}:${minutes}`;
            setCurrentTime(timeString);
        };

        updateTime(); // Update immediately

        // Time until the next full minute
        const now = new Date();
        const msUntilNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

        // Kick off the first update at the next minute mark
        const timeoutId = setTimeout(() => {
            updateTime(); // Sync to the minute

            // Then update every minute
            const intervalId = setInterval(updateTime, 60000);
            // Store intervalId for cleanup
            intervalRef.current = intervalId;
        }, msUntilNextMinute);

        // Clear timeout and interval on unmount
        const intervalRef = { current: null };
        return () => {
            clearTimeout(timeoutId);
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, []);

    const handleMenuSelect = (action) => {
        setShowMenu(false);
        switch (action) {
            case 'account':
                alert('帳號資訊');
                break;
            case 'report':
                alert('月報輔助工具');
                break;
            case 'logout':
                alert('登出成功');
                break;
            default:
                break;
        }
    };

    const handleMouseEnter = () => {
        clearTimeout(timeoutRef.current);
        setShowMenu(true);
    };

    const handleMouseLeave = () => {
        // Delay closing to avoid flicker on quick hover
        timeoutRef.current = setTimeout(() => {
            setShowMenu(false);
        }, 150);
    };

    const canToggleSidebar = typeof onToggleSidebar === 'function';

    return (
        <header className="header">
            <div className="header_container">
                <div className="header_left">
                    <h1 className="header_title" onClick={() => navigate('/')}>
                        {title}
                    </h1>
                </div>
                <div className="header_right">
                    <div className="header_right-info">
                        <h1 className="header_name">歡迎 {user?.name || ''}</h1>

                        <h1 className="header_date">{currentTime}</h1>
                    </div>
                    {isMobile && canToggleSidebar && (
                        <button
                            type="button"
                            className={`header_menu-toggle${
                                isSidebarOpen ? ' header_menu-toggle--active' : ''
                            }`}
                            onClick={onToggleSidebar}
                            aria-label={isSidebarOpen ? '關閉選單' : '開啟選單'}
                            aria-expanded={isSidebarOpen}
                        >
                            <FiMenu />
                        </button>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;
